module.exports = __webpack_public_path__ + "static/media/1010675.660cddfb.jpg";